module.exports = __webpack_public_path__ + "img/listado.bbe395c2.png";